import "./InfoIcon.scss";

export const InfoIcon = () => {
  return (
    <div className="infoIconContainer">
      <i
        className="fa-solid fa-info"
        style={{ transform: "translate(0.5px, -0.5px)" }}
      ></i>
    </div>
  );
};
